"use client";
import React from "react";
import PageLayout from "@/layouts/pageLayout";
import PocCloudTabs from "@/components/pageTabs/pocCloudTabs";
import Faqs from "./components/faqs";
import Hero from "./components/hero";
import Intro from "./components/intro";
import FeaturesComponent from "./components/features";
import WhyOneMind from "./components/whyOnemind";
import OfferingsComponent from "./components/offerings";

const NetworkDigitalTwinsPage = () => {
  return (
    <PageLayout showContactForm>
      <Hero />
      <PocCloudTabs />
      <Intro />
      <FeaturesComponent />
      <WhyOneMind />
      <OfferingsComponent />
      <Faqs />
    </PageLayout>
  );
};

export default NetworkDigitalTwinsPage;
